<template>
  <div>
    <h3 class="font-semibold uppercase text-gray-600">Add Vehicle Type</h3>
    <form @submit.prevent="update">
      <div class="flex -mx-4 items-strech">
        <div class="w-1/2">
          <div class="p-4 space-y-4">
            <label class="block">
              <span class="text-gray-700">Vehicle Type Name</span>
              <input
                v-model="vehicleType.name"
                class="form-input mt-1 block w-full"
                placeholder="Luxury"
              />
            </label>
            <label class="block">
              <span class="text-gray-700">Cost per KMs</span>
              <input
                v-model="vehicleType.pricePerKM"
                class="form-input mt-1 block w-full"
                placeholder="$"
              />
            </label>
            <div class="flex -mx-4">
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Rent Price per Day</span>
                    <input
                      v-model="vehicleType.rentPerDay"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Rent Price per Hour</span>
                    <input
                      v-model="vehicleType.rentPerHour"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="flex -mx-4">
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Price for Hard Workers</span>
                    <input
                      v-model="vehicleType.priceForHardWorkers"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Price for Medium Workers</span>
                    <input
                      v-model="vehicleType.priceForMediumWorkers"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="flex -mx-4">
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Base Fare</span>
                    <input
                      v-model="vehicleType.baseFare"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Surge Price</span>
                    <input
                      v-model="vehicleType.surgePrice"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="flex -mx-4">
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Price per Minute</span>
                    <input
                      v-model="vehicleType.pricePerMin"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
              <div class="w-1/2">
                <div class="px-4">
                  <label class="block">
                    <span class="text-gray-700">Number of Seats</span>
                    <input
                      v-model="vehicleType.numberOfSeats"
                      class="form-input mt-1 block w-full"
                    />
                  </label>
                </div>
              </div>
            </div>
            <label class="block">
              <span class="text-gray-700">Status</span>
              <select @change="setStatus" class="block form-select w-full mt-1">
                <option value="1" :selected="vehicleType.active">On</option>
                <option value="0" :selected="!vehicleType.active">Off</option>
              </select>
            </label>
          </div>
        </div>
        <div class="w-1/2">
          <div class="p-4">
            <photo-uploader
              v-model="vehicleType.photo"
              label="Vehicle Type Image"
            />
          </div>
        </div>
      </div>
      <div>
        <button
          class="px-4 py-2 text-white font-semibold rounded"
          :disabled="busy"
          :class="
            busy
              ? 'bg-500-100 cursor-not-allowed'
              : 'bg-blue-500 hover:bg-blue-700'
          "
        >
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import PhotoUploader from "@/components/PhotoUploader.vue";

export default {
  components: {
    PhotoUploader,
  },
  data() {
    return {
      busy: false,
      vehicleType: {
        photo: "",
        name: "",
        pricePerKM: 0,
        active: false,
        rentPerDay: 0,
        rentPerHour: 0,
        priceForHardWorkers: 0,
        priceForMediumWorkers: 0,
        baseFare: 0,
        surgePrice: 0,
        pricePerMin: 0,
        numberOfSeats: 0,
      },
    };
  },
  created() {
    this.getVehicleType();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    setStatus(e) {
      this.vehicleType.active = e.target.value === "1";
    },
    update() {
      this.busy = true;
      this.$http
        .patch(`/vehicleTypes/${this.id}`, { ...this.vehicleType })
        .then(() => {
          this.$router.push("/vehicle-types");
          window.flash({
            type: "success",
            body: "Vehicle Type edited successfully!",
          });
        })
        .catch(err => console.log(err))
        .finally(() => (this.busy = false));
    },
    getVehicleType() {
      this.$http
        .get(`vehicleTypes/${this.id}`)
        .then(response => (this.vehicleType = response.data))
        .catch(err => console.log(err));
    },
  },
};
</script>
